const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/portfolio_/view/$viewId/swimlane/preview/$visualizationId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { portfolioBeforeLoad } from '@/routes/(app)/org/$org/loop/$loopId/portfolio/route';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/portfolio_/view/$viewId/swimlane/preview/$visualizationId')({
  beforeLoad: portfolioBeforeLoad,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    hideChrome: true,
    hideSidebarNav: true
  }
});